import React, { useCallback, useContext } from 'react'
import { Alert } from 'components'
import { Button } from 'components/Form'
import { useMutation } from '@tanstack/react-query'
import { updateToMissedFetch } from 'store/middlewares/assessment.crud'
import { AssessmentsContext } from './AssessmentsContext'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { keys, pickBy } from 'lodash'

const UpdateMissedAlert = (props) => {
    const { handleAlert = () => { } } = props
    const { setResetRowSelection, selectedAssessments, setSelectedAssessments } = useContext(AssessmentsContext)

    const successQuery = useCallback(() => {
        handleAlert(false)
        setResetRowSelection(true)
        setSelectedAssessments(null)
        toast("הסוללות עודכנו בהצלחה", toastConfig)
    }, [])

    const { mutateAsync: updateBatteriesToMissed, isPending: duplicateGroupIsPending } = useMutation({
        mutationFn: updateToMissedFetch,
        onSuccess: () => {
            successQuery()
        }
    })

    const updateAssessments = useCallback(() => {
        const assessment_ids = keys(pickBy(selectedAssessments, v => v === true));
        updateBatteriesToMissed({ student_battery_ids: assessment_ids })
    }, [selectedAssessments])

    return (
        <Alert
            systemUI
            title={"עדכון המבדקים של הסוללות שנבחרו לחלף המועד"}
            footerActions={[]}
            handleAlert={() => handleAlert(false)}
            closeOnClick
        >
            <Button
                loading={false}
                // disabled={}
                action={updateAssessments}
                color="thirdly"
                label="ביצוע"
            />
        </Alert>
    )
}

export default UpdateMissedAlert